import { memo, useEffect,useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useLiveStreamAppContext } from "../ContextStore/Store";

//Following Component is for End Call Popup when End Call Button is Clicked from Navbar
function ClassAppointmentExitPopup(props) {
  const [BrowserName, setBrowserName] = useState(false);
  const [status, setStatus] = useState("Click the button to allow camera & mic");
  const videoRef = useRef(null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // if (/iPhone|iPad|Macintosh/i.test(userAgent)) {
    //   setIsMacOs(true);
    // }

    if (/Chrome/.test(userAgent) && !/Edg|OPR/.test(userAgent)) {
      setBrowserName("Chrome");
    } else if (/Safari/.test(userAgent) && !/Chrome|CriOS|Edg/.test(userAgent)) {
      setBrowserName("Safari");
    } else if (/Firefox/.test(userAgent)) {
      setBrowserName("Firefox");
    } else if (/Edg/.test(userAgent)) {
      setBrowserName("Edge");
    } else {
      setBrowserName("Other");
    }


  }, []);

     const handleRequestAccess = async () => {
      props.onHide(false);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      navigator.permissions?.query({ name: "camera" }).then(result => {
      //console.log("Camera permission:", result.state);
});
 if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
      // ✅ Permission granted
      setStatus("✅ Access granted to camera and microphone");

      // Always stop the stream immediately if you're not using it yet
      stream.getTracks().forEach((track) => track.stop());
    } catch (error) {
      // ❌ Permission denied or error
      if (error.name === "NotAllowedError") {
        setStatus("❌ Access denied. Please allow it in browser settings.");
      } else if (error.name === "NotFoundError") {
        setStatus("❌ No camera or microphone found.");
      } else {
        setStatus(`❌ Error: ${error.message}`);
      }
    }
  };
  return (
    <Modal
      className="livestreamPopup"
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4 className="modal-title">{props.headtext}</h4>
            {/* Cross Button */}
            {!(props.devicePermissionModal === true) && (
              <i
                className="font-awesome-light-pro live-popup-close"
                onClick={() => props.onHide(false)}
                style={{ cursor: "pointer" }}
              >
                &#xf00d;
              </i>

            )}
          </Modal.Title>
        </Modal.Header>
        {/* Popup Message According to type of live stream */}
        <Modal.Body className="clearfix default-scrollbar">
          <div className="discText">
            <p style={{ whiteSpace: "pre-line" }}>{props.message}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {(props.buttontext === "Open Browser Settings" ) && (
            BrowserName ? (
              <>
                {" "}
                {!(props.devicePermissionModal === true) && (
                  <button
                    className="cbtn brd-btn margin-right16"
                    onClick={() => {
                      if (typeof props.onHide === "function") {
                        props.onHide(false);
                      } else {
                        console.error("onHide is not a function");
                      }
                    }}
                  >
                    Cancel
                  </button>
                )}
                <button
                ref={videoRef}
                  className={`cbtn thm-btn`}
                  style={{
                    textDecoration: "none",
                  }}
                  onClick={handleRequestAccess}
                  target="_blank"
                  rel="noreferrer"
                >
                  {props.buttontext}
                </button>
              </>
            ) : (
              <button
                className="cbtn thm-btn"
                onClick={() => {
                  if (typeof props.onHide === "function") {
                    props.onHide(false);
                  } else {
                    console.error("onHide is not a function");
                  }
                }}
              >
                OK
              </button>
            )
          )}
          {(props.buttontext !== "Open Browser Settings"  )  &&(
            <>
              {!(props.devicePermissionModal === true) && (
                <button
                  className="cbtn brd-btn margin-right16"
                  onClick={() => {
                    if (typeof props.onHide === "function") {
                      props.onHide(false);
                    } else {
                      console.error("onHide is not a function");
                    }
                  }}
                >
                  Cancel
                </button>
              )}
              {/* End Button According to the Type of live stream */}
              <button
                className="cbtn thm-btn"
                disabled={props.hostbuttonloader}
                onClick={() => {              
                  if (typeof props.handleEndCall === "function") {
                    props.handleEndCall();     
                  } else {
                    console.error("handleEndCall is not a function");
                  }
                }}
              >
                {props.buttontext}
              </button>
            </>
          )}
        </Modal.Footer>
      </div>
    </Modal>
  );
}
export default memo(ClassAppointmentExitPopup);